<script setup>
  const colorMode = useColorMode()

  const applyColorMode = (mode) => {
    if (mode.value && mode.value === 'dark') document.documentElement.classList.add('dark')
    else document.documentElement.classList.remove('dark')
  }

  applyColorMode(colorMode)

  watch(colorMode, (mode) => {
    applyColorMode(mode)
  })
</script>

<template>
  <div>
    <NuxtPage />
  </div>
</template>

<style>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;1,200;1,300;1,400;1,500;1,600;1,700&display=swap');
</style>
 